import { useAuth } from "@/context/AuthContext";

const RANK = { none: 0, view: 1, edit: 2 };

export const SECTIONS = [
  { key: "cheques", label: "Çekler" },
  { key: "receivables", label: "Alacaklar" },
  { key: "expenses", label: "Giderler" },
  { key: "recurring", label: "Tekrarlayanlar" },
  { key: "cash", label: "Merkez Kasa" },
  { key: "cash_bagcilar", label: "Bağcılar Kasa" },
  { key: "bank_accounts", label: "Banka Hesapları" },
];

export const LEVEL_LABELS = {
  none: "Kapalı",
  view: "Sadece Görüntüle",
  edit: "Tam Yetki",
};

export function hasPermission(user, section, level = "view") {
  if (!user) return false;
  if (user.role === "admin") return true;
  const perms = user.permissions || {};
  const got = perms[section] || "none";
  return (RANK[got] || 0) >= (RANK[level] || 1);
}

export function usePermission(section, level = "view") {
  const { user } = useAuth();
  return hasPermission(user, section, level);
}
